import { gql } from '@apollo/client';
import ClientOnly from '../ClientOnly';
import OptimizedImage from '../OptimizedImage';

export default function FeaturedImage({
  image,
  width,
  height,
  className,
  priority,
  layout,
  objectFit = 'cover',
  type = 'hero', // Default to hero type for featured images
  index = 0,
  ...props
}) {
  const src = image?.sourceUrl;
  const { altText } = image || '';

  width = width ? width : image?.mediaDetails?.width;
  height = height ? height : image?.mediaDetails?.height;
  layout = layout ?? 'fill';

  return src ? (
    <figure className={className}>
      <ClientOnly>
        <OptimizedImage
          src={src}
          alt={altText}
          type={type}
          index={index}
          {...(layout === 'fill' 
            ? { fill: true }
            : { width, height }
          )}
          priority={priority}
          style={{ objectFit }}
          {...props}
        />
      </ClientOnly>
    </figure>
  ) : null;
}

FeaturedImage.fragments = {
  entry: gql`
    fragment FeaturedImageFragment on NodeWithFeaturedImage {
      featuredImage {
        node {
          id
          sourceUrl
          altText
          mediaDetails {
            width
            height
          }
        }
      }
    }
  `,
};
